<template>
  <div class="red_packet_view">
    <div class="header_top">
      <div class="go_back">
        <i class="el-icon-arrow-left"></i>
        <span @click="goBack">返回</span>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick" class="el_tabs">
        <el-tab-pane label="红包详情" name="details"></el-tab-pane>
        <el-tab-pane label="发送明细" name="list"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="content">
      <red-packet-data v-show="activeName === 'details'"></red-packet-data>
      <red-packet-statement v-show="activeName === 'list'"></red-packet-statement>
    </div>
  </div>
</template>
<script>
import redPacketData from './redPacketData';
import redPacketStatement from './redPacketStatement';

export default {
  components: { redPacketData, redPacketStatement },
  data() {
    return {
      activeName: 'details',
    };
  },
  created() {
    const breadcrumb = [
      { menu_name: '企业微信管理', menu_path: '' },
      { menu_name: '企业红包', menu_path: 'enterpriseRedPacket' },
    ];
    breadcrumb.push({ menu_name: '查看红包' });
    this.g_breadcrumb(breadcrumb);
  },

  methods: {
    handleClick() {},
    goBack() {
      this.$emit('changeComponet', 'redPacketList');
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
